import { atom } from 'jotai';

import { Maybe } from '@/types';
import { SvgCamiseta, SvgEscudo } from '@/types/editProfile';

export type TshitAndShieldTypes = {
  shield: SvgEscudo;
  tshirt: SvgCamiseta;
};

export const defaultShieldTeam = {
  escudoparam1: '',
  escudoparam2: '31',
  escudoparam3: 'dddddd',
  escudoparam4: 'ffffff',
  escudoparam5: '',
};

export const defaultTshirtTeam = {
  param1: '1',
  param2: '31',
  param3: 'ffffff',
  param4: 'dddddd',
  param5: '99',
};

export const initialTshitAndShield: TshitAndShieldTypes = {
  shield: defaultShieldTeam as SvgEscudo,
  tshirt: defaultTshirtTeam as SvgCamiseta,
};

export const tshirtAndShieldAtom = atom<Maybe<TshitAndShieldTypes>>(
  initialTshitAndShield
);
